import React, { useState } from 'react'

import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import { IconButton } from '@mui/material'
import CustomerUserEditModal from 'features/customers/components/users/CustomerUserEditModal'
import { useCustomerUserRemove } from 'features/customers/hooks/useCustomerUserRemove'
import { useCustomerUserUpsert } from 'features/customers/hooks/useCustomerUserUpsert'

import { ConfirmModal } from 'components/_base'

type CustomerUserActionsProps = {
  user: Record<string, any>
  userId: number
}

const CustomerUserActions = ({ user, userId }: CustomerUserActionsProps) => {
  const [modal, setModal] = useState<string | null>(null)

  const { mutateAsync: upsertCustomerUser } = useCustomerUserUpsert()
  const { mutateAsync: removeCustomerUser } = useCustomerUserRemove()

  const handleOpenModal = (type: any) => () => setModal(type)
  const handleCloseModal = () => setModal(null)

  const handleRemoveUser = async () => {
    await removeCustomerUser({ userId })
    handleCloseModal()
  }

  const handleEdit = async (values: any) => {
    await upsertCustomerUser({ userId, ...values })
    handleCloseModal()
  }

  const { job_department, job_title, role } = user
  const initialValues = {
    jobDepartment: job_department,
    jobTitle: job_title,
    roleId: role.id.toString(),
  }

  return (
    <>
      <IconButton aria-label="Edit" disabled={!userId} onClick={handleOpenModal('edit')} size="large">
        <EditIcon />
      </IconButton>
      <IconButton aria-label="Delete" disabled={!userId} onClick={handleOpenModal('delete')} size="large">
        <DeleteIcon />
      </IconButton>
      {modal === 'edit' && (
        <CustomerUserEditModal initialValues={initialValues} onClose={handleCloseModal} onSubmit={handleEdit} />
      )}
      <ConfirmModal
        onClose={handleCloseModal}
        onConfirm={handleRemoveUser}
        open={modal === 'delete'}
        title="Confirm delete customer user"
      />
    </>
  )
}

export default CustomerUserActions
